import React from 'react'

 let About=()=> {
    return (
        <div className="card">
            <h1 className="text-center">About</h1>
            <p className="text-center">Search Github users and their five latest repo</p>
            <p className="text-center">Version: 1.0.0</p>
        </div>
    )
};

export default About;
